export const allNumbersRegex = /^[0-9]+$/;
export function validateForm(input, customValidation = {}) {
    const errors = {};
    Object.entries(input).forEach(([key, value]) => {
        const expectedType = typeof value;
        const validation = customValidation[key];
        if (value !== undefined && validation?.dependOn) {
            const { ckey, cvalue } = validation.dependOn;
            if (input[ckey] !== cvalue) {
                if (value === null || value === undefined || value === "") {
                    errors[key] = `${validation?.name || ckey.replace(/_/g, " ")} as it depends on ${ckey.replace(/_/g, " ")}`;
                }
            }
        }
        else {
            if (value !== undefined) {
                if (value === null || value === "") {
                    errors[key] = `${validation?.name || key.replace(/_/g, " ")} is required`;
                }
                else if (key === "email" && !validateEmail(value)) {
                    errors[key] = `${validation?.name || key.replace(/_/g, " ")} must be a valid email address`;
                }
                else if ((key === "phone" || key == "contact_number") && !validatePhone(value)) {
                    errors[key] = `${validation?.name || key.replace(/_/g, " ")} must be a 10-digit phone number`;
                }
            }
        }
    });
    const isValid = Object.keys(errors).length === 0;
    return { errors, isValid };
}
export function validateEmail(email) {
    // email validation regex
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return regex.test(email);
}
function validatePhone(phone) {
    // phone number validation regex
    const regex = /^\d{10}$/;
    return regex.test(phone);
}
export function isNumberValue(value) {
    return allNumbersRegex.test(value.replace(/\s+/g, ""));
}
export function isEmptyValue(value) {
    const isObject = typeof value === "object";
    return value === "" || value === null || value === undefined || (Array.isArray(value) && value.length === 0) || (isObject && Object.keys(value).length === 0);
}
